export default __webpack_public_path__ + "static/niche@mob_2x-9cc1266faf7700291c4b2c454a434bba.png";